<template>
  <v-footer dark padless>

    <v-container class="secondary white--text text-center" fluid>
      <v-row class="text-center">
        <v-col class="align-self-center webkit-center hidden-sm-and-down" cols="12" md="4">
          <v-img alt="Logo Unimol" max-width="210" src="@/assets/img/unimol-with-text.png"/>
        </v-col>
        <v-col class="align-self-center" cols="12" md="4">
          <v-card-text class="white--text pt-1">
            <p>
              <a href="mailto:info@bb-smile.net" target="_blank">info@bb-smile.net</a>
              <br>
              <a href="https://goo.gl/maps/X5jJszqht51mYN4r8" target="_blank">
                Pesche (IS) 86090 - C.da Fonte Lappone snc c/o Università del Molise </a>
              <br>
              P.IVA 00996250940
            </p>
          </v-card-text>
        </v-col>
        <v-col class="align-self-center webkit-center hidden-sm-and-down" cols="12" md="4">
          <v-img alt="Logo Sapienza" max-width="270" src="@/assets/img/sapienza-with-text.png"/>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12">
          <v-card-text class="white--text">
            Copyright &copy; {{ new Date().getFullYear() }} — <strong>BB-SMILE</strong>
          </v-card-text>
        </v-col>
      </v-row>
    </v-container>

  </v-footer>
</template>

<style scoped>
.v-card {
  width: 100%;
}

.webkit-center {
  text-align: -webkit-center;
}
</style>

<script>
export default {
  data: () => ({
    icons: [
      {
        text: "mdi-linkedin",
        link: "https://www.linkedin.com/company/bb-smile",
      },
    ],
  }),
};
</script>
